import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

const MAX_CONTACTS = 1000;

/** Fetch a user's NIP-02 contact list (kind 3), returning followed pubkeys. */
export function useContacts(pubkey: string | undefined) {
  const { nostr } = useNostr();

  return useQuery<string[]>({
    queryKey: ['nostr', 'contacts', pubkey ?? ''],
    queryFn: async () => {
      if (!pubkey) return [];

      const [event] = await nostr.query(
        [{ kinds: [3], authors: [pubkey], limit: 1 }],
        { signal: AbortSignal.timeout(4000) },
      );

      if (!event) return [];

      const pubkeys: string[] = [];
      for (const [name, value] of event.tags) {
        if (name === 'p' && value && !pubkeys.includes(value)) {
          pubkeys.push(value);
        }
        if (pubkeys.length >= MAX_CONTACTS) break;
      }
      return pubkeys;
    },
    enabled: !!pubkey,
    staleTime: 10 * 60 * 1000,
  });
}
